import PdfDocumentPreview from "./PdfDocumentPreview.jsx";

export default function PdfPayRunPreview({ payRunId, isPreparing = false }) {
  return (
    <PdfDocumentPreview
      documentId={payRunId}
      endpointBase="/pay-runs/pdf"
      isPreparing={isPreparing}
      emptyMessage="Generate a pay run preview to view the real PDF."
      preparingTitle="Preparing pay run preview"
      preparingText="Generating the pay run and loading the real PDF."
    />
  );
}
